// Files
import CONFIG from "@/config/config.js";
import MUTATIONS from "./mutations";
import ACTIONS from "./actions";
import GETTERS from "./getters/getters";

const browserModule = {
  state: () => ({
    ...CONFIG,

    // Rest
    currentInvestment: null,
    flats: [],
    fetchingFlats: false,
    favourites: [],
    errorMessage: null,
    filters: [],
    sorting: {
      property: CONFIG.flatProperties["status"],
      order: 1,
    },
    constantFilters: [],
    sidebarActive: false,
    favouritesSidebarActive: false,
    favouritesQuery: null,
  }),
  mutations: {
    ...MUTATIONS,
  },
  actions: {
    ...ACTIONS,
  },
  getters: {
    ...GETTERS,
  },
};

export default browserModule;
